<template>
  <ul class="product-features-list__list">
    <li
      class="product-features-list__item"
      v-for="(feature, featureIndex) in features"
      :key="`${featureIndex}_feature`"
    >
      <span
        v-if="feature.headline && feature.values.length > 0"
        class="product-features-list__label"
      >
        {{ feature.headline }}
      </span>
      <template
        v-for="(featureValue, featureValueIndex) in feature.values"
        :key="`${featureValueIndex}_name`"
      >
        <span
          class="product-features-list__label"
        >
          {{ featureValue.name }}
        </span>
        <span
          class="product-features-list__value"
          v-html="featureValue.value"
        />
      </template>
    </li>
  </ul>
</template>

<script lang="ts">
  import {Options, Prop, Vue} from 'vue-property-decorator';

  @Options({
    name: 'product-features-list-inner'
  })
  export default class ProductFeaturesListInner extends Vue {
    @Prop()
    features: Array<{
      headline: string,
      values: Array<{
        name: string,
        value: string
      }>
    }>;
  }
</script>
